// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-2VhMK4t5","sub_logo":"sub_logo-207EkDvY","breadcrumbs":"breadcrumbs-1JLgiS4W"};